<template>
  <!-- -->
  <div class="simple-pie">
    <div class="pie" :style="{'background-image': `conic-gradient(${normalColor} ${rateDeal}%, ${warnColor} 0 100%)`}">{{centerInfo}}</div>
  </div>
</template>

<script>

import {useRoute, useRouter} from "vue-router";
import {watch} from "vue";

export default {
  props: {
    allCount: {default: 100}, // 总数
    validCount: {default: 30}, // 有效数据，不需要报警的数量
    centerInfo: {default: "已处理"}, // 显示在中心的信息
    warnColor: {default: "#d14f28"},
    normalColor: {default: "#97e5ef"},
    numberInvalidColor: {default: "#ccc"},
    numberLength: {default: 6},
  },
  setup() {
    return {
      router: useRouter(),
      route: useRoute(),
    }
  },
  name: "WarnPie",
  components: {
  },
  data() {
    return {
      rateDeal: 66
    };
  },
  created() {
    this.count();
    watch(() => this.allCount, () => this.count());
    watch(() => this.validCount, () => this.count());
  },
  methods: {
    count() {
      if (!this.allCount) {
        return;
      }
      this.rateDeal = Math.floor(this.validCount / this.allCount * 100);
    }
  }
};
</script>

<style lang="scss" scoped>
.simple-pie{
  aspect-ratio: 1/1;
  height: 100%;
  border-radius: 164px;
  box-sizing: border-box;
  padding: 10px;
  border: 2px dotted #aaa;
  margin-left: 20px;
  display: inline-block;
  .pie{
    width: 100%;
    height: 100%;
    border-radius: 50%;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #FFF;
  }
}
</style>